export default "__VITE_ASSET__I0VYSOaL__"